import _ from 'lodash';
const MJ_FONT_FAMILY_MATCHER = '\\sfont-family="([^"]+)"';
const STYLES_MATCHER = '\\sstyle="([^"]+)"';
const FONT_FAMILY_IN_STYLES_MATCHER = 'font-family:([^;]+);?';
export const resolveFontsFromMjml = mjml => {
  const mjFonts = [...mjml.matchAll(new RegExp(MJ_FONT_FAMILY_MATCHER, 'gm'))].map(match => match[1]);
  const styles = [...mjml.matchAll(new RegExp(STYLES_MATCHER, 'gm'))].map(match => _.unescape(match[1]));
  const fontsFromStyles = styles.map(style => [...style.matchAll(new RegExp(FONT_FAMILY_IN_STYLES_MATCHER, 'gm'))]).flat().map(matches => matches[1].trim());
  return [...mjFonts, ...fontsFromStyles];
};
//# sourceMappingURL=resolveFontsFromMjml.js.map